import React, { PropsWithChildren } from 'react';
import { WagmiProvider } from 'wagmi';
import useConfig from '../../hooks/useConfig';
import QueryClientProvider from '../QueryClientProvider';

const Provider = ({ children }: PropsWithChildren) => {
  const { config } = useConfig();

  return (
    <QueryClientProvider>
      <WagmiProvider config={config}>{children}</WagmiProvider>
    </QueryClientProvider>
  );
};

export default Provider;
